import { render } from "./CustomPosition.vue?vue&type=template&id=3981160a"
import script from "./CustomPosition.vue?vue&type=script&lang=js"
export * from "./CustomPosition.vue?vue&type=script&lang=js"
script.render = render

export default script